import request from "../utils/request";
const config = require("../config/settings.json");

export async function getReceipt(id) {
	
	return request(`${config.apiUrl}/receipts/${id}`, {
		method: "GET",
	}).catch((err) => {});
}
